import Vue from 'vue'
import Vuetiy from 'vuetify/lib'
import {Vuetify} from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import ru from 'vuetify/src/locale/ru'

Vue.use(Vuetiy as Vuetify, {
  theme: {
    primary: '#5794e4',
    secondary: '#424242',
    accent: '#5794e4',
    error: '#e45757',
    info: '#2196F3',
    success: '#0ea014',
    warning: '#f89200',
    loading: '#5794e4',
  },
  customProperties: true,
  iconfont: 'md',
  lang: {
    locales: { ru },
    current: 'ru'
  }
})
